<template>
  <register-container style="height: 100%" :contentStyle="{ height: '100%', position: 'relative' }">
    <div
      style="
        margin: auto;
        max-width: 800px;
        position: absolute;
        inset: 0;
        height: fit-content;
        max-height: 100%;
        overflow: auto;
      "
      :style="{
        transform: `translateY(calc(-${$vuetify.breakpoint.smAndDown ? '70px' : '120px'} * 0.5))`,
      }"
      class="pa-2 flex-grow-1"
    >
      <TruformeLoader
        v-if="polling"
        style="transform: unset !important; margin: auto; width: fit-content"
      >
        Waiting for payment...
      </TruformeLoader>
      <v-card outlined elevation="0" v-else-if="!invoicePaid">
        <v-card-text>
          <div class="text-overline px-4">Invoice</div>
          <v-card-title> Virtual Assessment </v-card-title>
          <v-card-subtitle>Services provided by Sentry Health</v-card-subtitle>
          <div class="font-weight-bold px-4" style="font-size: 2rem">${{ invoiceTotal }}</div>
        </v-card-text>
        <v-card-actions class="pa-4 d-flex justify-end">
          <v-btn @click="payNow" color="primary" elevation="0" large style="width: 250px"
            >Pay Invoice</v-btn
          >
        </v-card-actions>
      </v-card>

      <div v-else class="d-flex flex-column align-center" style="gap: 16px">
        <v-icon :size="$vuetify.breakpoint.mdAndUp ? '100' : '50'" color="success"
          >mdi-checkbox-marked-circle</v-icon
        >
        <p>Payment received!</p>
        <div class="d-flex justify-center">
          <v-btn text color="success" @click="end">Next</v-btn>
        </div>
      </div>
    </div>
  </register-container>
</template>
<script>
import GET_INVOICE from '@/graphql/Query/GetInvoice.gql';
import RegisterContainer from '../components/RegisterContainer.vue';
import TruformeLoader from '../components/Truforme/TruformeLoader.vue';

export default {
  name: 'TruformePayInvoice',
  components: {
    RegisterContainer,
    TruformeLoader,
  },
  data() {
    return {
      invoicePaid: false,
      polling: false,
    };
  },
  computed: {
    completed() {
      return this.invoicePaid;
    },
    invoice() {
      return this.$store.state.registration.invoice;
    },
    invoiceTotal() {
      if (!this.invoice?.total) return '00.00';
      return (this.invoice.total / 100).toFixed(2);
    },
  },
  methods: {
    end() {
      window.dispatchEvent(new CustomEvent('GO_NEXT_PAGE'));
    },
    async getInvoice() {
      try {
        const data = await this.$apollo.query({
          query: GET_INVOICE,
          variables: {
            providerId: this.$store.getters.getProviderId(),
            stripeInvoiceId: this.invoice.stripeInvoiceId,
          },
          fetchPolicy: 'no-cache',
        });
        return data?.data?.getInvoice || {};
      } catch {
        return {};
      }
    },
    async pollInvoice() {
      this.polling = true;
      const { status } = await this.getInvoice();

      if (status !== 'paid') {
        setTimeout(() => {
          this.pollInvoice();
        }, 1000);
      } else {
        this.invoicePaid = true;
        this.polling = false;
      }
    },
    payNow() {
      const { hostedInvoiceUrl } = this.invoice;
      window.open(hostedInvoiceUrl, '_blank');
      this.pollInvoice();
    },
  },
  async mounted() {
    this.$store.commit('setOnNextClick', () => {
      if (this.isPageflowV2) {
        this.$emit('next');
      } else {
        this.$router.push({ name: this.$store.getters.nextFlowRoute(this.$route.name) });
      }
    });
  },

  watch: {
    invoicePaid: {
      immediate: true,
      handler(val) {
        if (!val) return;
        setTimeout(() => {
          this.end();
        }, 500);
      },
    },
  },
};
</script>
